import axios from 'axios';
import get from 'lodash/get';

// Libs
import { thunkErrorHanlder, parseUrl } from '../../libs/utils';

// Constants
import {
  ROLE_PERMISSIONS,
} from '../../constants/endpoints';

export const ALL_ROLE_PERMISSIONS = 'ALL_ROLE_PERMISSIONS';

/**
 * getRolePermissions - This function get role permissions
 * @return {object} object with role permissions
 */
export async function getRolePermissions(id) {
  function parseRolePermissions(response, dispatch){
    const rolePermissions = get(response, 'data.data.permissions');
    dispatch({ type: ALL_ROLE_PERMISSIONS, payload: rolePermissions });

    return rolePermissions;

  } // END parseRolePermissions

  return dispatch => axios.get(parseUrl(ROLE_PERMISSIONS, { id }))
    .then(response => parseRolePermissions(response, dispatch))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getRolePermissions




// WEBPACK FOOTER //
// ./src/redux/actions/suraRolePermissionsActions.js